import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import VenueUI from './Components/VenueUI';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Calendar from './Components/Calendar';
import Artists from './Components/Artists';
import Venues from './Components/Venues';
import Login from './Auth/Login'
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './Auth/AuthContext';
import 'react-toastify/dist/ReactToastify.css';
import RequireAuth from './Auth/RequireAuth';
import RequireAdmin from './Auth/RequireAdmin';
import ResetPassword from './Auth/ResetPassword';
import Bookings from './Components/Bookings';
import ConfirmGig from './Components/ConfirmGig';
import DeclineGig from './Components/DeclineGig';
import Dashboard from './Components/Dashboard';
import EventManager from './Components/EventManager';
import Accounting from './Components/Accounting';
import AdminUI from './Components/AdminUI';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <ToastContainer position='top-center' />
    <BrowserRouter>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/confirm/:id' element={<ConfirmGig />} />
        <Route path='/decline/:id' element={<DeclineGig />} />

        <Route element={<RequireAuth />} >
          <Route path='/' element={<VenueUI />}>
            <Route index element={<Dashboard />} />
            <Route path='musicians' element={<Artists />} />
            <Route path='venues' element={<Venues />} />
            <Route path='bookings' element={<Bookings />} />
            <Route element={<RequireAdmin />}>
              <Route path='template' element={<EventManager />} />
              <Route path='accounting' element={<Accounting />} />
              <Route path='admin' element={<AdminUI />} />
            </Route>
          </Route>

        </Route>
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);